import { useState, useRef, useCallback } from 'react';
import useEvent from '../useEvent/index.js';

function useControlledState(defaultValue, control) {
  var _a = useState(defaultValue),
    state = _a[0],
    setState = _a[1];
  var initiallyControlled = useRef(typeof control.value !== 'undefined');
  var value = initiallyControlled.current ? control.value : state;
  var cb = useEvent(control.onChange);
  var onChange = useCallback(function (setter) {
    var _setter = setter;
    var newValue = typeof setter === 'function' ? _setter(value) : setter;
    if (!initiallyControlled.current) {
      setState(newValue);
    }
    cb === null || cb === void 0 ? void 0 : cb(newValue);
  }, [cb, value]);
  return [value, onChange];
}

export { useControlledState as default };
